module.exports = __webpack_public_path__ + "static/media/lr-logo-footer.eb31c885.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/lr-logo-footer.svg
// module id = 330
// module chunks = 0